import React from 'react';
import styled from 'styled-components';
import type { PropsOf } from '@peloton/react';
import { defaultTransition, media } from '@peloton/styles';
import { spaces } from '@engage/styles';
import { useClasses, Classes } from '@members/copy';
import { WhiteBookmarkIcon } from '@members/icons';

const Button = styled.button`
  position: absolute;
  right: 10px;
  top: 0;
  z-index: 1;
  display: flex;
  justify-content: flex-end;
  width: 40px;

  /* Animations */

  ${defaultTransition('transform')}
  transform: scaleY(1);
  transform-origin: top;

  &:focus {
    outline: none;
  }

  &:hover,
  &:focus {
    transform: scaleY(1.15);
  }

  &:active {
    transition-duration: 10ms;
    transform: scaleY(1.2);
  }

  ${media.tablet`
    right: 15px;
  `}

  @media (hover: none) {
    padding-right: 5px;
    padding-bottom: ${spaces.small}px;
    right: 5px;
    -webkit-tap-highlight-color: transparent;

    &:active,
    &:hover,
    &:focus {
      transform: scaleY(1);
    }

    ${media.tablet`
      right: 10px;
    `}
  }
`;

type BookmarkButtonProps = PropsOf<typeof WhiteBookmarkIcon> & {
  isBookmarked: boolean;
};

export const BookmarkButton: React.FC<React.PropsWithChildren<BookmarkButtonProps>> = ({
  isBookmarked,
  onClick,
  ...props
}) => (
  <Button
    onClick={e => {
      e.preventDefault();
      if (onClick) {
        onClick(e as any);
      }
    }}
    aria-pressed={isBookmarked}
    aria-label={useClasses(Classes.AriaBookmark)}
    data-test-id="videoCellBookmark"
  >
    <WhiteBookmarkIcon {...props} />
  </Button>
);
